import {
  DEFAULT_SKUP_PILE_LAYOUTS,
  DEFAULT_SKUP_PILE_TUNE,
  mergeSkupPileLayouts,
  parseSkupPileStore,
  type SkupPileLayout,
  type SkupPileTune,
} from "@ziolo/shared";

export const SKUP_PILE_LAYOUTS_KEY = "ziolo.bottle-clicker.skup-layouts.v1";

export function loadSkupPileStore(): { tune: SkupPileTune; layouts: SkupPileLayout[] } {
  try {
    const raw = localStorage.getItem(SKUP_PILE_LAYOUTS_KEY);
    if (!raw) {
      return {
        tune: { ...DEFAULT_SKUP_PILE_TUNE },
        layouts: mergeSkupPileLayouts(DEFAULT_SKUP_PILE_LAYOUTS, []),
      };
    }
    const parsed = parseSkupPileStore(JSON.parse(raw) as unknown);
    return {
      tune: parsed.tune,
      layouts: mergeSkupPileLayouts(DEFAULT_SKUP_PILE_LAYOUTS, parsed.layouts),
    };
  } catch {
    return {
      tune: { ...DEFAULT_SKUP_PILE_TUNE },
      layouts: mergeSkupPileLayouts(DEFAULT_SKUP_PILE_LAYOUTS, []),
    };
  }
}

export function persistSkupPileStore(store: {
  tune: SkupPileTune;
  layouts: SkupPileLayout[];
}): void {
  try {
    localStorage.setItem(SKUP_PILE_LAYOUTS_KEY, JSON.stringify(store));
  } catch {
    // Private mode — the heap just does not stick.
  }
}

export function clearSkupPileLayouts(): void {
  try {
    localStorage.removeItem(SKUP_PILE_LAYOUTS_KEY);
  } catch {
    // ignore
  }
}
